import {
  DONATION_HISTORY_LOADING,
  DONATION_HISTORY_SUCCESS,
  DONATION_HISTORY_FAILURE,
} from "redux/types";

const initialState = {
  donationHistoryLoading: false,
  donationHistory: null,
  errors: null,
};

export const donationHistoryReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case DONATION_HISTORY_LOADING:
      return { ...state, donationHistoryLoading: action.payload };
    case DONATION_HISTORY_SUCCESS:
      return { ...state, donationHistory: action.payload };
    case DONATION_HISTORY_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
